import { defineComponent } from "vue";
import HomeListTitle from "./homeListTitle.vue";
import MusicList from "@/components/music-list/musicList.vue";
export default defineComponent({
  name: "Djprogram",
  props: {
    djprogramList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    return {};
  },
  components: {
    HomeListTitle: HomeListTitle,
    MusicList: MusicList
  }
});